import { Box, Typography } from '@mui/material';
import moment from 'moment';

import { formatEntityId, history } from '../../../helpers';
import {
  FORTA_BLUE,
  FORTA_ERROR,
  FORTA_ORANGE,
  FORTA_SUCCESS,
  FORTA_WHITE,
} from '../../../utils/colors';
import { ENTITY_PREFIX } from '../../../constants';
import { cardChipStyles } from '../constants';

import type { ITPPriorAuthorizations } from '../../../utils/types';

interface TPExpirationCardProps {
  priorAuthorization: ITPPriorAuthorizations;
}

function TPExpirationCard({ priorAuthorization }: TPExpirationCardProps) {
  const { client, days_until_expiry, date_end, active_treatment_plan_id } = priorAuthorization;
  const clientName = `${client.first_name} ${client.last_name}`;
  const label =
    days_until_expiry > 0
      ? `${days_until_expiry} ${days_until_expiry === 1 ? 'day' : 'days'}`
      : 'Expired';
  const statusColor =
    days_until_expiry > 60 ? FORTA_SUCCESS : days_until_expiry > 30 ? FORTA_ORANGE : FORTA_ERROR;

  const handleClick = () => {
    if (!active_treatment_plan_id) return;
    history.navigate(`/treatment-plan/${active_treatment_plan_id}/client-info`);
  };

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: FORTA_WHITE,
        borderRadius: '8px',
        mb: 1,
        mr: 1,
        cursor: active_treatment_plan_id ? 'pointer' : 'default',
        border: `1px solid ${statusColor}`,
        '&:hover': {
          boxShadow: `1px 2px 4px rgba(0, 0, 0, 0.2)`,
        },
      }}
      onClick={handleClick}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography textAlign="left" fontWeight={600} color={FORTA_BLUE.dark}>
          {clientName}
        </Typography>
        <Typography
          sx={{
            ...cardChipStyles,
            fontWeight: 400,
            backgroundColor: statusColor,
            color: FORTA_WHITE,
            width: '87px',
            textAlign: 'center',
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          mt: 1,
        }}
      >
        <Typography sx={cardChipStyles} mt={1}>
          {`Expiration date: ${moment(date_end).format('MM/DD/YYYY')}`}
        </Typography>
        <Typography sx={cardChipStyles} mt={1}>
          {active_treatment_plan_id
            ? formatEntityId(active_treatment_plan_id, ENTITY_PREFIX.TreatmentPlan)
            : 'No Active TP'}
        </Typography>
      </Box>
    </Box>
  );
}

export default TPExpirationCard;
